// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__25ZQu","tab":"ProcedureTabs_tab__jURd1"};